import { Typography } from '@material-ui/core'
import React from 'react'

type Props = {
  text: string
}

export function EmptyTableContainer({ text }: Props): React.ReactElement {
  return <Typography variant="subtitle1">{text}</Typography>
}
